<div class="simulations-container">
  <div class="simulations-header">
    <h1 class="title">{{ title }}</h1>
  </div>

  <div class="simulations-content">
    @if (runningSimulations().length === 0) {
      <div class="no-simulations">
        <p>No active simulations running.</p>
      </div>
    } @else { @for (simulation of runningSimulations(); track simulation.runId) {
      <div class="simulation-card">
        <div class="card-buttons">
          @if(simulation.status === 'Waiting' && simulation.userEmail === currentUserEmail){
            <button class="btn btn-cancel" (click)="onSimulationAction(simulation.runId, 'Cancel')">
              <span>CANCEL</span>
            </button>
          }
          @if(simulation.status === 'Failure' && simulation.userEmail === currentUserEmail){
            <button class="btn btn-cancel" (click)="onSimulationAction(simulation.runId, 'Cancel')">
              <span>CANCEL</span>
            </button>
            <button class="btn btn-primary" (click)="onSimulationAction(simulation.runId, 'Retry')">
              <span>RETRY</span>
            </button>
          }
        </div>
        <div class="detail-row">
          <span class="label">Name: </span>
          <span class="value">{{ simulation.name || '' }}</span>
        </div>
        <div class="detail-row">
          <span class="label">Type: </span>
          <span class="value">{{ simulation.type }}</span>
        </div>
        <div class="detail-row">
          <span class="label">Rock file: </span>
          <span class="value">{{ getFileNameWithoutExtension(simulation.fileName) }}</span>
        </div>
        <div class="detail-row">
          <span class="label">Created at: </span>
          <span class="value">{{ simulation.createdTime | date : 'MMM d, y, h:mm a' }}</span>
        </div>
        <div class="detail-row">
          <span class="label">Created by: </span>
          <span class="value">{{ simulation.userEmail }}</span>
        </div>
        <div class="detail-row">
          <span class="label">Direction: </span>
          <span class="value chips-row">
            <span class="direction-label">{{ simulation.direction.toUpperCase() }}:&nbsp;</span>
            <mat-chip [ngClass]="getStatusClass(simulation.status)" class="status-chip">{{ simulation.status }}</mat-chip>
          </span>
        </div>
        @if (simulation.status !== 'Failure') {
          <div class="detail-row">
            <mat-progress-bar
              [mode]="simulation.progress === 0 ? 'buffer' : 'determinate'"
              [value]="simulation.progress"
            ></mat-progress-bar>
          </div>
        }
      </div>
      } }
    </div>
  </div>
